<!-- ProductId: {{ productId() }} -->

<app-action-bar-items [locationId]="'product-trading-set-configurator'">
    <ng-template #preList>
        <div class="flex gap-1">
            <p-button
                icon="fa fa-save"
                [disabled]="loading() || this.editNode() == null"
                (onClick)="save([this.editNode()])"
            ></p-button>
            <p-button
                icon="fa fa-plus"
                severity="primary"
                outlined="true"
                (onClick)="addNewProduct()"
                [disabled]="loading() || this.editNode() != null"
            ></p-button>
            <p-button
                icon="fa fa-trash"
                severity="primary"
                outlined="true"
                (onClick)="deleteTradingSetNode(selectedNode)"
                [disabled]="!selectedNode || loading() || this.editNode() != null"
            ></p-button>
            <p-message #tradingSetInfoBar severity="info" class="ms-2">
                <div class="flex gap-4">
                    <span>
                        {{ 'trading-set.calc-price' | translate }} :
                        {{ tradingSetCalcPriceSig() | decimalPlacesCustom: this.decimalPlaces() }}
                    </span>
                    |
                    <span>
                        {{ 'trading-set.last-purchase-price' | translate }} :
                        {{
                            tradingSetLastPurchasePriceSig()
                                | decimalPlacesCustom: this.decimalPlaces()
                        }}
                    </span>
                    |
                    <span>
                        {{ 'trading-set.average-purchase-price' | translate }} :
                        {{
                            tradingSetAveragePurchasePriceSig()
                                | decimalPlacesCustom: this.decimalPlaces()
                        }}
                    </span>
                </div>
            </p-message>
        </div>
    </ng-template>
    <ng-template #postList>
        <div class="flex gap-1">
            <!-- toggle sidebar button -->
            <!-- for now hide this feature -->
            <!-- <p-button
            icon="fa fa-bars"
            label="{{ 'product.toggle-product-sidebar' | translate }}"
            (onClick)="toggleSidebar()"
        ></p-button> -->
        </div>
    </ng-template>
</app-action-bar-items>

<div class="flex overflow-hidden mb-2">
    <div class="flex grow">
        <!-- Center Panel -->
        <div class="flex flex-col w-full">
            <!-- PRODUCT LIST AND EDIT -->
            <p-splitter styleClass="w-full" layout="vertical">
                <ng-template pTemplate>
                    <!-- <div
                        class="flex w-full drop-table-container"
                        pDroppable="products"
                        (onDrop)="drop()"
                    ></div> -->
                    <p-table
                        #tradingSetTable
                        [value]="dataNodes()"
                        [scrollable]="true"
                        selectionMode="single"
                        editMode="row"
                        [(selection)]="selectedNode"
                        [tableStyle]="{ 'min-width': '50rem' }"
                        styleClass="w-full"
                        class="w-full"
                        dataKey="key"
                    >
                        <ng-template pTemplate="header">
                            <tr>
                                <!-- NOT SUPPORTED YET -->
                                <!-- <th>{{ 'common.order' | translate }}</th> -->
                                <th>{{ 'product.identifier' | translate }}</th>
                                <th>{{ 'product.description' | translate }}</th>
                                <th class="!text-right">
                                    {{ 'product.calc-price' | translate }}
                                </th>
                                <th class="!text-right">
                                    {{ 'product.item-purchase-last-price' | translate }}
                                </th>
                                <th class="!text-right">
                                    {{ 'product.item-purchase-average-price' | translate }}
                                </th>
                                <th class="!text-right">
                                    {{ 'common.quantity' | translate }}
                                </th>
                                <th>{{ 'product.unit' | translate }}</th>
                                <th class="!text-center w-[50px]">
                                    <span class="ps-1 pe-1">
                                        <i class="fa-solid fa-gear" style="color: #4a4e55"></i>
                                    </span>
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template
                            pTemplate="body"
                            #body
                            let-rowData
                            let-rowIndex="rowIndex"
                            let-editing="editing"
                            let-columns="columns"
                        >
                            <!-- {{ r | json }} -->
                            <tr
                                [pSelectableRow]="rowData"
                                [pSelectableRowIndex]="rowIndex"
                                [pEditableRow]="rowData"
                                [pContextMenuRow]="rowData"
                                (dblclick)="onRowEditInit(rowData, rowIndex)"
                                pReorderableRow
                            >
                                <!-- POSITION + TOGGLE -->
                                <!-- NOT SUPPORTED YET -->
                                <!-- <td>
                                    <span class="fa fa-bars" pReorderableRowHandle></span>
                                    <p-treeTableToggler [rowNode]="rowNode" />
                                    {{ r.order }}
                                </td> -->
                                <!-- IDENTIFIER -->
                                <td>{{ rowData.data.childProduct?.identifier }}</td>
                                <!-- DESCRIPTION -->
                                <td>
                                    <!-- <p-cellEditor [id]="'description'">
                                        <ng-template pTemplate="input">
                                            <app-phx-input
                                                [(ngModel)]="rowData.data.childProduct.description"
                                            ></app-phx-input>
                                        </ng-template>
                                        <ng-template pTemplate="output"> -->
                                    {{ rowData.data.childProduct?.description }}
                                    <!-- </ng-template>
                                    </p-cellEditor> -->
                                </td>
                                <td class="!text-right">
                                    {{
                                        rowData.data.childProduct?.calculatoryCosts
                                            | decimalPlacesCustom: this.decimalPlaces()
                                    }}
                                </td>
                                <td class="!text-right">
                                    {{
                                        rowData.data.childProduct?.lastPurchasePrice
                                            | decimalPlacesCustom: this.decimalPlaces()
                                    }}
                                </td>
                                <td class="!text-right">
                                    {{
                                        rowData.data.childProduct?.averagePurchasePrice
                                            | decimalPlacesCustom: this.decimalPlaces()
                                    }}
                                </td>

                                <!-- QUANTITY -->
                                <td class="!text-right">
                                    <p-cellEditor [id]="'quantity'">
                                        <ng-template pTemplate="input">
                                            <app-phx-input-number
                                                [(ngModel)]="rowData.data.quantity"
                                            />
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ rowData.data.quantity }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <!-- UNIT -->
                                <td>
                                    <p-cellEditor [id]="'unit'">
                                        <ng-template pTemplate="input">
                                            <!-- TODO, dont allow change set per product-->
                                            <!-- <app-unit-drop-down [(value)]="r.unit" /> -->
                                            {{ rowData.data.childProduct?.unit?.identifier }}
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{ rowData.data.childProduct?.unit?.identifier }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <!-- ACTIONS -->
                                <td class="w-[50px]">
                                    <div class="icon-buttons">
                                        @if (
                                            this.editNode()?.key === rowData.key &&
                                            this.editNode() != null
                                        ) {
                                            <!-- i left rowData.disabled in it - since maybe we want to implement it later - and it doesnt break anything -->
                                            <a
                                                [ngClass]="{
                                                    'text-slate-300': rowData?.disabled,
                                                    'hover:text-slate-300': rowData?.disabled,
                                                    'text-green-500': !rowData?.disabled,
                                                    'hover:text-green-300': !rowData?.disabled,
                                                    'clickable': !rowData?.disabled
                                                }"
                                                class="fa-solid fa-check ms-1"
                                                tabindex="0"
                                                (keyup.enter)="onRowEditSave(rowData, rowIndex)"
                                                (click)="onRowEditSave(rowData, rowIndex)"
                                            ></a>
                                            <!-- UNDO Edit Button -->
                                            <a
                                                [ngClass]="{
                                                    'text-slate-300': rowData?.disabled,
                                                    'hover:text-slate-300': rowData?.disabled,
                                                    'text-slate-600': !rowData?.disabled,
                                                    'hover:text-slate-400': !rowData?.disabled,
                                                    'clickable': !rowData?.disabled
                                                }"
                                                class="fa-solid fa-rotate-left ms-2 me-1"
                                                tabindex="0"
                                                (keyup.enter)="onRowEditCancel(rowData, rowIndex)"
                                                (click)="onRowEditCancel(rowData, rowIndex)"
                                            ></a>
                                        } @else {
                                            <a
                                                tabindex="0"
                                                class="fa-solid fa-plus ms-1 text-slate-600 hover:text-slate-400"
                                                (click)="loading() ? null : addNewProduct(rowData)"
                                                [ngClass]="{ 'clickable': !loading() }"
                                            ></a>
                                            <a
                                                tabindex="0"
                                                class="fa-solid fa-times ms-2 me-1 text-red-600 hover:text-red-400"
                                                (click)="
                                                    loading() ? null : deleteTradingSetNode(rowData)
                                                "
                                                [ngClass]="{ 'clickable': !loading() }"
                                            ></a>
                                        }
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="'100%'" class="text-center p-4">
                                    <div class="text-gray-500 p-4 justify-self-center">
                                        <p>{{ 'common.no-items' | translate }}</p>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </ng-template>
                <!-- PRODUCT EDIT TEMPLATE -->
                @if (editProductFeature()) {
                    <ng-template pTemplate>
                        <div class="flex items-center justify-center">
                            <!-- Product Preview -->

                            PRODUCT EDIT WIDGET

                            <!-- <app-product-edit-widget
                                    [modelId]="productId()"
                                ></app-product-edit-widget> -->
                        </div>
                    </ng-template>
                }
            </p-splitter>
        </div>
    </div>
    <!-- Product Sidebar. Cant have inside splitter right now: https://github.com/primefaces/primeng/issues/15940 -->
    @if (productSidebarVisible()) {
        <p-card styleClass="m-2" class="animate-fadeinright">
            <div class="flex-none flex" style="min-width: 20rem">
                <p-iconField iconPosition="right" class="w-full">
                    <p-inputIcon styleClass="fa fa-search" />
                    <input type="text" pInputText placeholder="Search" class="w-full" />
                </p-iconField>
            </div>
            <!-- ITEMS -->
            <div>
                <div *ngFor="let product of productsFromSearch()">
                    <div
                        class="product-item"
                        pDraggable="products"
                        (onDragStart)="dragStart(product)"
                        (onDragEnd)="dragEnd()"
                    >
                        <div class="product-list-detail">
                            <h5 class="mb-2">
                                {{ product.identifier }}
                            </h5>
                            <i class="pi pi-tag product-category-icon"></i>
                            <span class="product-category">
                                {{ product.description }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </p-card>
    }
</div>

<app-action-bar-items [locationId]="'product-trading-set-price-lists'" class="mt-2">
    <ng-template #preList>
        <p-button
            icon="fa fa-arrows-rotate"
            severity="primary"
            outlined="true"
            (onClick)="reloadPriceInfos()"
        ></p-button>
    </ng-template>
</app-action-bar-items>
<div class="flex flex-col w-full">
    <p-table
        #tradingSetPriceInfoTable
        [value]="this.priceInfos()"
        [scrollable]="true"
        selectionMode="single"
        [(selection)]="selectedNode"
        [tableStyle]="{ 'min-width': '50rem' }"
        styleClass="w-full"
        class="w-full"
        dataKey="key"
    >
        <ng-template pTemplate="header">
            <tr>
                <!-- NOT SUPPORTED YET -->
                <!-- <th>{{ 'common.order' | translate }}</th> -->
                <th class="">{{ 'trading-set.price-list' | translate }}</th>
                <th
                    class="!text-right"
                    [pTooltip]="'trading-set.set-price-positions-tooltip' | translate"
                >
                    {{ 'trading-set.set-price-positions' | translate }}
                </th>
                <th
                    class="!text-right"
                    [pTooltip]="'trading-set.set-price-header-tooltip' | translate"
                >
                    {{ 'trading-set.set-price-header' | translate }}
                </th>
                <th
                    class="!text-right"
                    [pTooltip]="'trading-set.set-price-difference-tooltip' | translate"
                >
                    {{ 'trading-set.set-price-difference' | translate }}
                </th>
                <th
                    class="!text-right"
                    [pTooltip]="'trading-set.revenue-positions-tooltip' | translate"
                >
                    {{ 'trading-set.revenue-positions' | translate }}
                </th>
                <th
                    class="!text-right"
                    [pTooltip]="'trading-set.revenue-header-tooltip' | translate"
                >
                    {{ 'trading-set.revenue-header' | translate }}
                </th>
                <th
                    class="!text-right"
                    [pTooltip]="'trading-set.revenue-difference-tooltip' | translate"
                >
                    {{ 'trading-set.revenue-difference' | translate }}
                </th>
            </tr>
        </ng-template>
        <ng-template
            pTemplate="body"
            #body
            let-rowData
            let-rowIndex="rowIndex"
            let-columns="columns"
        >
            <!-- {{ r | json }} -->
            <tr
                [pSelectableRow]="rowData"
                [pSelectableRowIndex]="rowIndex"
                [pContextMenuRow]="rowData"
                pReorderableRow
            >
                <!-- POSITION + TOGGLE -->
                <!-- NOT SUPPORTED YET -->
                <!-- <td>
                                    <span class="fa fa-bars" pReorderableRowHandle></span>
                                    <p-treeTableToggler [rowNode]="rowNode" />
                                    {{ r.order }}
                                </td> -->
                <!-- IDENTIFIER -->
                <td>
                    <app-price-list-display-row-widget
                        [priceListSig]="rowData.priceList"
                        [dataTestid]="
                            dataTestid() +
                            '-product-trading-set-configurator-widget-price-list-display-row-widget'
                        "
                    />
                </td>
                <td class="!text-right">
                    {{ rowData.setPriceItems | decimalPlacesCustom: this.decimalPlaces() }}
                </td>
                <td class="!text-right">
                    {{ rowData.setPriceHeader | decimalPlacesCustom: this.decimalPlaces() }}
                </td>
                <td class="!text-right">
                    {{ rowData.setPriceDifference | decimalPlacesCustom: this.decimalPlaces() }}
                </td>
                <td class="!text-right">
                    {{ rowData.revenueItems | decimalPlacesCustom: this.decimalPlaces() }}
                </td>
                <td class="!text-right">
                    {{ rowData.revenueHeader | decimalPlacesCustom: this.decimalPlaces() }}
                </td>
                <td class="!text-right">
                    {{ rowData.revenueDifference | decimalPlacesCustom: this.decimalPlaces() }}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="'100%'" class="text-center p-4">
                    <div class="text-gray-500 p-4 justify-self-center">
                        <p>{{ 'common.no-items' | translate }}</p>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<!-- p:{{ productSidebarVisible() }} -->
<!-- {{ selectedNode | json }} -->
